// Vue 2's Bootstrap 3 dropdown menu, for Vue 3 ports of its menus
export const BOOTSTRAP_MENU_SIDE_OFFSET = 2
export const BOOTSTRAP_MENU_CLASSES =
  'min-w-40 rounded-xs border-black/15 bg-white px-0 py-[5px] text-md shadow-[0_6px_12px_rgba(0,0,0,0.175)]'
export const BOOTSTRAP_MENU_OPTION_CLASSES =
  'cursor-pointer rounded-none px-5 py-[3px] leading-5 text-gray-900 focus:bg-gray-100 focus:text-[#262626]'
